<template>

  <div class="videoContainer">
    <video 
      ref="watchVideo" 
      id="example_video" 
      preload="auto" 
      playsinline="true" 
      webkit-playsinline="true"  
      x5-playsinline="true" 
      x5-video-player-fullscreen="true" 
      x5-video-player-type="h5"

      name="media" 
      autoplay="true"
      muted 
      width="100%" 
      height="100%"
      class="fullscreenVideo"
      :poster="videoPoster" 
      :src="videoSrc"
      @ended="videoEnd"
    ></video>

    <!-- <video
      webkit-playsinline="true"
      x-webkit-airplay="true" 
      playsinline="true" 
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true" 
      width="100%" 
      height="100%"
      id="example_video" 
      class="video-js " 
      preload='auto'
      autoplay='true'
      loop
      muted
      :poster="videoPoster" 
      >
      <source :src="videoSrc" type="video/mp4">
    </video> -->

    <a class="icp" href="http://beian.miit.gov.cn/" target="_blank">
      沪ICP备16013855号-1
    </a>
  </div>

   <!-- <div class="videoContainer" @click="link">
    <video class="fullscreenVideo" id="bgVid" playsinline="" autoplay muted="" loop="">
      <source src="../../img/bg-video.mp4" type="video/mp4">
    </video>
    <a class="icp" href="http://beian.miit.gov.cn/" target="_blank">
      沪ICP备16013855号-1
    </a>
  </div> -->

  <!-- <div class="start-page" @click="link">
    <div class="bg-block">
      <div class="content">
        <img src="../../img/start/logo.png" class="logo" />
      </div>

      <a class="icp" href="http://beian.miit.gov.cn/" target="_blank">
        沪ICP备16013855号-1
      </a>
    </div>
  </div> -->
</template>

<script>
// import { gsap } from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// gsap.registerPlugin(ScrollTrigger)
// import $ from 'jquery'
export default {
  data() {
    return {
      videoPoster: '../../img/nav-logo.png',
      videoSrc: '',
      videoSrc2: require('@/video/bg-video2.mp4'),
      videoSrc3: require('@/video/bg-video3.mp4')
    }
  },
  components: {
  },
  mounted() {
    if (this._isMobile()) {
      console.log('mobile')
      this.videoSrc = this.videoSrc3
    } else {
      console.log('pc')
      this.videoSrc = this.videoSrc2
    }
    // var video = document.getElementById("example_video");
    // var video = this.$refs.watchVideo;
    // video.play();

    //视频自动播放
    this.$nextTick(()=>{
      var video = document.getElementById("example_video");

      if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge.invoke === 'function') {
        window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
          video.play();
        });
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', function () {
            video.play();
          }, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', function () {
            video.play();
          });
        }
      }
    })
  },
  destroyed(){
    // this.videoPlayer.dispose(); //销毁video
    //或者重置video
    this.$nextTick(()=>{
      var video = document.getElementById("example_video");
      video.reset();
    })
  },
  methods: {
    //App.vue
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    videoEnd() {
      this.link()
    },
    link() {
      this.$router.push({
        path: '/home'
      });
    },
    autoGo(){
      const TIME_COUNT = 4;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(()=>{
        if ( this.count > 0 && this.count <= TIME_COUNT ) {
          this.count--;
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
          // 跳转的页面写在此处
          this.link();
          // this.$router.push({
          //   path: '/home'
          // });
        }
        },1000)
      }
    }
  }
};
</script>

<style scoped lang="less">
// 方案2
.video-background {
  // background-color: red;
  // color: #FFF;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: -100;
  video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    object-fit: cover;
    transform: translateX(-50%) translateY(-50%);
  }
  // object-fit: cover;
}
// 方案2
.videoContainer {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -100;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1;
    top: 0;
    left: 0;
    background-size: cover;
  }
  .fullscreenVideo {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// old style
.icp {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  margin: 0 auto;
  font-size: 12px;
  color: #D8D8D8;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
}
.start-page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  .bg-block {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      // height: 100vh;
      // background-image: url(../../img/start/bg.jpg);
      background-image: url(../../img/start/bg2.jpg);
      background-repeat: no-repeat;
      // background-size: 1920px 1080px;
      justify-content: center;
      background-size: cover;
      background-position: center center;
      z-index: 1;
      .content {
        color: #FFF;
        width: 1100px;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .title {
          width: 620px;
          height: 87px;
        }
        .logo {
          // width: 203px;
          // height: 30px;
          width: 406px;
          height: 60px;
        }
        a {
          display: block;
          margin-top: 50px;
        }
        .btn {
          width: 210px;
          height: 39px;
        }
      }
  }
  
}
</style>